<div class="modal-header">
  <h4 class="modal-title">
    Групово изтриване
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body" nzForceRepaint>
  <div class="alert alert-danger">
    <p class="mb-2">
      Избраните съобщения ще бъдат изтрити окончателно и няма да има възможност да бъдат възстановени.
      Може да изтриете само избрани съобщения или да изберете всички.
    </p>
    <p class="mb-0">
      <strong>Внимание:</strong> Това действие е необратимо.
    </p>
  </div>
  @if (loadingData) {
    <div class="text-center">
      <h3>
        <i class="text-muted fa-solid fa-spinner fa-spin"></i>
      </h3>
      <h5 class="text-muted">Зареждане...</h5>
    </div>
  } @else {
    @if (conversations.length === 0) {
      <h5 class="my-5 text-muted text-center">Не бяха намерени съобщения, които могат да бъдат изтрити.</h5>
    } @else {
      <div class="mb-2 mt-4 d-flex">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="select-all"
            [checked]="areAllSelected()"
            (change)="toggleSelectAll($event)">
          <label for="select-all" class="form-check-label">
            Изберете всички
          </label>
        </div>
      </div>
      <ul class="list-unstyled">
        @for (conversation of conversations; track conversation.conversationUserId) {
          <li class="mb-2 d-flex bg-light border rounded-3 cursor-pointer hover-shadow"
              (click)="toggleSelection(conversation.conversationUserId)">
            <div class="my-auto ms-2 form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="checkbox-{{ conversation.conversationUserId }}"
                [checked]="selectedConversationsIds.includes(conversation.conversationUserId)">
            </div>
            <div class="d-flex bg-body-secondary">
              <div class="my-auto card-image">
                <nz-image [imageUrl]="environment.apiImageAdUrl + '/main/' + conversation.adId"></nz-image>
              </div>
            </div>
            <div class="p-2">
              <div class="pb-2 lh-1 text-primary-emphasis">
                {{ conversation.isUserAdOwner ? 'Купувач ' : 'Продавач ' }}
                {{ conversation.interlocutorUsername }}
              </div>
              <div class="lh-1 small text-muted">{{ conversation.adTitle }}</div>
            </div>
          </li>
        }
      </ul>
    }
  }
</div>
<div class="modal-footer d-block text-end">
  <button
    type="button"
    class="me-2 btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
  <button
    type="button"
    class="btn btn-danger"
    (click)="onSubmit()"
    [disabled]="loadingData || loadingSubmit || selectedConversationsIds.length === 0">
    @if (loadingSubmit) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    <span>Изтрий</span>
  </button>
</div>
